/**
 *  Receives an array of tags: ["#code", "#ttp"]
 *  Returns the name without the #
 * */
export function stripTags(tagString: string[]): string[] {
  const newTagString = [];

  for (let t = 0; t < tagString.length; t++) {
    const strippedTag = String(tagString[t]).replace("#", "");
    newTagString.push(strippedTag);
  }

  return newTagString;
}

export function tagFormatter(tag: null | string[]): string[] {
  if (tag == null) {
    tag = [""];
  } else {
    for (let t = 0; t < tag.length; t++) {
      tag[t] = tag[t].replace("#", "").toLowerCase();
    }
  }

  return tag;
}

export function _getTagNumber(tag: string): number {
  // returns first digit thats in a tag, used for mood tags, energy tags, etc.
  return parseInt(tag.match(/\d/));
}
